<h2 mat-dialog-title>Select Date Range</h2>
<div mat-dialog-content>
  <mat-form-field appearance="outline">
    <mat-label>Start Date</mat-label>
    <input matInput [matDatepicker]="startPicker" [(ngModel)]="start" placeholder="Start date">
    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
  </mat-form-field>
  <span style="margin: 0 8px;">to</span>
  <mat-form-field appearance="outline">
    <mat-label>End Date</mat-label>
    <input matInput [matDatepicker]="endPicker" [(ngModel)]="end" placeholder="End date">
    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
    <mat-datepicker #endPicker></mat-datepicker>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onApply()" [disabled]="!start || !end">Apply</button>
</div> 